export default __webpack_public_path__ + "static/media/arrow-circle.9f45e8e7.svg";